<template>
  <div class="home-page">
    <el-card class="query-card">
      <!-- 按人员编号查询成绩 -->
      <div class="query-item">
        <el-input v-model="shooterNo" placeholder="请输入人员编号" class="query-input" maxlength="6" @input="shooterNo = shooterNo.replace(/[^\d]/g, '').replace(/^0+/, '')" clearable />
        <el-button type="success" @click="handleShooterQuery">
          按人员编号查询成绩
        </el-button>
      </div>
      <!-- 按场次名称查询成绩 -->
      <div class="query-item">
        <el-select v-model="activityId" filterable placeholder="请选择场次名称" clearable style="width: 100%">
          <el-option v-for="activity in activities" :key="activity.id" :label="activity.activityName" :value="activity.id"></el-option>
        </el-select>
        <el-button type="primary" @click="handleActivityQuery">
          按场次名称查询成绩
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import store from '../store';
import activityApi from '../api/activity';

export default {
  name: 'Home',
  data() {
    return {
      shooterNo: '', // 人员编号输入值
      activityId: '', // 场次对应的id

      activities: [],
      hasLoaded: false,
    }
  },
  computed: {
    userOrgs() {
      // 层级空值保护，避免userInfo不存在时报错，兜底返回空数组
      return this.$store.state.user?.userInfo?.orgs || [];
    }
  },
  watch: {
    userOrgs: {
      handler(newVal) {
        // 仅当有组织数据、且未加载过时，才执行请求
        if (newVal.length > 0 && !this.hasLoaded) {
          this.loadActivities();
          this.hasLoaded = true;
        }
      },
      immediate: true, // 组件初始化时立即执行，处理已有数据的场景
      deep: true // 深度监听数组变化
    }
  },
  methods: {
    loadActivities() {
      // 组装请求参数
      const params = {
        userOrgIds: this.userOrgs.map(org => org.id), 
      };
      activityApi.findAll(params).then(response => {
        if (response.success) {
          this.activities = response.data.data
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载场次失败：' + error.message)
      })
    },
    // 按人员编号查询
    handleShooterQuery() {
      if (!this.shooterNo) {
        this.$message.warning('请输入人员编号');
        return;
      }
      // 跳转页面
      this.$router.push({
        name: 'RecordList',
        query: { shooterNo: this.shooterNo }
      });
    },
    // 按场次名称查询
    handleActivityQuery() {
      if (!this.activityId) {
        this.$message.warning('请选择场次名称');
        return;
      }
      // 跳转页面
      this.$router.push({
        name: 'RecordList',
        query: { activityId: this.activityId }
      });
    }
  }
}
</script>

<style scoped>
.home-page {
  flex: 1;
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
}
.query-card {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.query-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
  gap: 12px;
  width: 100%;
}
.query-input {
  width: 400px;
}
</style>